export const objectToQueryParams = (params) => {
  return Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null && value !== '')
    .flatMap(([key, value]) =>
      (Array.isArray(value) ? value : [value]).map((item) => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`)
    )
    .join('&');
}